import appStore from 'store';
import api from './api';
import LANGUAGE from '../../common/languages_code';

const store = {

    namespaced: true,

    state : {
        agreements : [],
        total: 0,
        languages : Object.keys(LANGUAGE).map(item => {
            return {code : item, desc : LANGUAGE[item]}
        })
    },

    mutations : {
        setAgreements (state,payload) {
            state.agreements = payload;
        },

        setTotal(state,payload) {
            state.total = payload;
        }
    },

    actions : {
        getAllAgreements({commit},data){
            api.getAgreements(data).then(response =>{
                commit('setAgreements',response.data.list);
                commit('setTotal',response.data.totalCount)
            })
        }
    }

}

appStore.registerModule('agreement', store);